import React from 'react'

import styles from './Spacer.scss';

const Spacer = (props) => {
  return (
  		<div className={styles.spacer} 
				style={{
                    height: props.height
                }}
  		 />
  )
}

export default Spacer



// WEBPACK FOOTER //
// ./src/components/atoms/Spacer/index.js